/*
Fit Categories
*/

class FitCategories extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const guide = document.querySelector('fit-guide');
    const buttons = this.querySelectorAll('button');

    this.addEventListener('click', (e) => {
      if (e.target.tagName !== 'BUTTON') {
        return;
      }

      const category = e.target.dataset.category;

      buttons.forEach((button) => {
        button.classList.remove('filter-active');
      });

      e.target.classList.add('filter-active');

      const onepieces = guide.querySelector('[data-garment="one-pieces"]');
      if (category === 'active') {
        onepieces.classList.remove('grid');
        onepieces.classList.add('hidden');
      } else {
        onepieces.classList.remove('hidden');
        onepieces.classList.add('grid');
      }

      guide.setCategory(category);
    });
  }
}

customElements.define('fit-categories', FitCategories);

/*
Fit Garments
*/

class FitGarments extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const guide = document.querySelector('fit-guide');
    const buttons = this.querySelectorAll('button');

    this.addEventListener('click', (e) => {
      const button = e.target.closest('button');
      if (button && button.tagName !== 'BUTTON') {
        return;
      }

      const garment = button.dataset.garment;

      buttons.forEach((button) => {
        button.classList.remove('active');
      });

      button.classList.add('active');

      guide.setGarment(garment);
    });
  }
}

customElements.define('fit-garments', FitGarments);

/*
Fit Styles
*/

class FitStyles extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const guide = this.closest('fit-guide');
    const styles = this.querySelectorAll('button');

    styles[0].classList.add('active');

    this.addEventListener('click', (e) => {
      if (e.target.tagName !== 'BUTTON') {
        return;
      }

      const style = e.target.innerHTML;

      styles.forEach((button) => {
        button.classList.remove('active');
        if (button.innerHTML == style) {
          button.classList.add('active');
        }
      });

      e.target.classList.add('active');
      guide.setStyle(style);
    });
  }
}

customElements.define('fit-styles', FitStyles);

/*
Fit Guide
*/

class FitGuide extends HTMLElement {
  constructor() {
    super();
    this.products = null;
    this.category = 'swim';
    this.garment = 'tops';
    this.fit_style = null;
  }

  connectedCallback() {
    this.products = Array.from(this.querySelectorAll('div[data-category'));
    const styleChild = this.querySelector('fit-styles button:first-child').innerHTML;
    if (styleChild) {
      this.fit_style = styleChild;
      this.renderUI();
    }
  }

  setCategory(category) {
    this.category = category;
    this.garment = 'tops';
    const garments = Array.from(document.querySelectorAll('fit-garments button'));
    garments.forEach((g) => g.classList.remove('active'));
    garments[3].classList.add('active');
    this.setActiveStyle();
    this.renderUI();
  }

  setGarment(garment) {
    this.garment = garment;
    this.setActiveStyle();
    this.renderUI();
  }

  setStyle(style) {
    this.fit_style = style;
    this.renderUI();
  }

  getActiveStyles(isMobile) {
    return isMobile
      ? this.products
          .filter((product) => {
            return product.dataset.category === this.category && product.dataset.garment == this.garment;
          })
          .map((product) => {
            return product.dataset.fitStyle;
          })
      : this.products
          .filter((product) => {
            return product.dataset.category === this.category && product.dataset.garment == this.garment;
          })
          .map((product) => product.dataset.fitStyle);
  }

  setActiveStyle() {
    const fitStyles = this.querySelector('fit-styles');
    const styles = this.getActiveStyles();

    // Only set to first style if no style is currently selected
    if (!this.fit_style) {
      this.fit_style = styles.length > 0 ? styles[0] : null;
    }
  }

  renderStylesNav(product) {
    //desktop
    const styleNav = product.querySelector('fit-styles');
    const styles = this.getActiveStyles();
    styleNav.innerHTML = '';

    styles.forEach((style) => {
      const button = document.createElement('button');

      button.innerHTML = style;
      button.classList.add(product.dataset.fitStyle === style ? 'active' : 'opacity-40', 'font-body-bold');

      styleNav.appendChild(button);
    });

    //mobile
    const guide = document.querySelector('fit-guide');
    const fitMobile = guide.querySelector('fit-mobile');
    const select = fitMobile.querySelector('select');
    const target = fitMobile.querySelector('.select-target');
    const mobStyles = this.getActiveStyles(true);
    select.innerHTML = '';

    mobStyles.forEach((style, idx) => {
      const option = document.createElement('option');

      option.value = style;
      option.innerHTML = style;

      // Set the currently selected style as selected, or fall back to first style
      if (style === this.fit_style || (idx === 0 && !this.fit_style)) {
        option.selected = true;
        target.innerHTML = style;
      }

      select.appendChild(option);
    });
  }

  renderUI() {
    let product;
    product = this.products.find((product) => {
      return (
        product.dataset.category === this.category &&
        product.dataset.garment === this.garment &&
        product.dataset.fitStyle === this.fit_style
      );
    });

    if (!product) {
      product = this.products.filter((p) => p.dataset.category === this.category)[0];
    }

    this.renderStylesNav(product);

    if (product) {
      this.products.forEach((p) => p.classList.remove('active'));
      product.classList.add('active');
    }

    Array.from(this.querySelectorAll('fit-garments button')).forEach((garment) => {
      const category = garment.dataset.category;
      if (this.category === category) {
        garment.style.display = 'block';
      } else {
        garment.style.display = 'none';
      }
    });
  }
}

customElements.define('fit-guide', FitGuide);

/*
Collection Carousel
*/

class CollectionCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const categories = Array.from(this.querySelectorAll('[data-cat-trigger]'));
    const carousels = Array.from(this.querySelectorAll('[id^="b-"]'));

    categories.forEach((category) => {
      category.addEventListener('click', (e) => {
        const c = e.target.dataset.catTrigger;
        const parent = this.querySelector(`[data-cat="${c}"]`);

        categories.forEach((cat) => {
          cat.classList.remove('filter-active');
        });
        parent.querySelector(`[data-cat-trigger="${c}"]`).classList.add('filter-active');

        carousels.forEach((carousel) => {
          carousel.classList.remove('active');
        });
        parent.classList.add('active');
      });
    });
  }
}

customElements.define('collection-carousel', CollectionCarousel);

class FrenzyCollectionCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const categories = Array.from(this.querySelectorAll('[data-cat-trigger]'));
    const carousels = Array.from(this.querySelectorAll('[id^="b-"]'));
    let isCarousel = false;
    categories.forEach((category) => {
      category.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const c = e.target.dataset.catTrigger;
        const configId = e.target.dataset.config ? e.target.dataset.config : null;
        const ABTestId = e.target.dataset.ab_test_id ? e.target.dataset.ab_test_id : null;
        const tabIndex = e.target.dataset.index;
        const placeholder_grid_limit = 4;
        let frenzyPlaceholder = '';
        frenzyPlaceholder +=
          '<div class="frenzy_landing_page_carousel_section landing_page_carousel-' +
          tabIndex +
          '" config_id="' +
          configId +
          '" data-ab_test_id="' +
          ABTestId +
          '">';
        frenzyPlaceholder += '<div class="frenzy_container">';
        frenzyPlaceholder += '<div class="frenzy_content_loader_row">';
        frenzyPlaceholder += '<div class="frenzy_loader_row loader_grid_' + placeholder_grid_limit + '">';
        for (var i = 0; i < placeholder_grid_limit; i++) {
          frenzyPlaceholder += '<div class="frenzy_loader_grid">';
          frenzyPlaceholder += '<figure><img src="https://cdn.frenzyai.click/plugin/placeholder.png"/></figure>';
          frenzyPlaceholder +=
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="16" fill="currentColor"><path opacity="0" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"></path><path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"><animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.8s" repeatCount="indefinite"></animateTransform></path></svg>';
          frenzyPlaceholder += '</div>';
        }
        frenzyPlaceholder += '</div>';
        frenzyPlaceholder += '</div>';
        frenzyPlaceholder += '</div>';
        frenzyPlaceholder += '</div>';
        const parent = this.querySelector(`[data-cat="${c}"]`);
        const carouselParent = parent.querySelector('.collection-carousel-products site-carousel');
        categories.forEach((cat) => {
          cat.classList.remove('filter-active');
        });
        parent.querySelector(`[data-cat-trigger="${c}"]`).classList.add('filter-active');

        carousels.forEach((carousel) => {
          carousel.classList.remove('active');
        });
        parent.classList.add('active');
        if (!parent.classList.contains('frenzy-loaded')) {
          parent.querySelector('.collection-carousel-products site-carousel').innerHTML = frenzyPlaceholder;
          frenzyTabsApiCall(configId, ABTestId, tabIndex);
          parent.classList.add('frenzy-loaded');
        }
      });
    });
  }
}

function frenzyTabsApiCall(configId, ABTestId, tabIndex) {
  const frenzy_recom_api = '/landing-page-recs';
  const frenzyApiName = 'landing_page_carousel';
  const self = document.querySelector(`.frenzy_landing_page_carousel_section.landing_page_carousel-${tabIndex}`);
  var data_json = JSON.stringify({
    user_id: user_id_Frenzy ? user_id_Frenzy.toString() : null,
    page: __st.p,
    shop: frenzyShop,
    num_matching: 15,
    full_description: true,
    config_id: configId,
    ab_test_id: ABTestId,
    currency: Shopify?.currency?.active ? Shopify?.currency?.active : '',
    country: Shopify.country ? Shopify.country : '',
    company_id: frenzy_company_id ? frenzy_company_id : null,
    location_id: frenzy_location_id ? frenzy_location_id : null,
  });

  getRecommendationAPIWithStructure(data_json, frenzy_recom_api, self, frenzyApiName, tabIndex);
}
customElements.define('frenzy-collection-carousel', FrenzyCollectionCarousel);
